module.exports = __webpack_public_path__ + "static/media/feelsgood.35abc5d2.mp3";